


import TiwiMixin from '../mixins/TiwiMixin'

// import PasswordRecoveryWidget from './PasswordRecoveryWidget'

export default {
  mixins: [ TiwiMixin ],
  // components: { PasswordRecoveryWidget },
  data: () => {
		return {
            // loading: false,
            current_state: 'login',
            show_password: false,

            email: '',
            password: ''
		}
	},
  methods:{
    clickLogin: function(){

      var self = this;
      self.setLoading(true);

      var post_data = {email: this.email, password: this.password };


      this.api.post('user/login', post_data )
        .then( (response) => {

          if( response.data.success ){
            self.toast.success( response.data.message );

            if(response.data.redirect)
              window.location.href = response.data.redirect;
            
          }
          else{
            self.toast.error( response.data.message );
            
          }
            
        })
        .catch( (error) => { 
          self.toast.error( 'Errore nella richiesta' );
        })
        .finally( () => self.setLoading(false) )

    },
    clickReset: function(){

      var self = this;
      self.setLoading(true);

      var post_data = {email: this.email };


      this.api.post('/user/request_password_recovery', post_data )
        .then( (response) => {

          if( response.data.success ){
            self.toast.success( response.data.message );
            self.current_state = 'login';
          }
          else{
            self.toast.error( response.data.message );
          }
            
        })
        .catch( (error) => { 
          self.toast.error( 'Errore nella richiesta' );
        })
        .finally( () => self.setLoading(false) )

      } 

    
  },
}
